import { ReactNode } from "react";
import InformationTooltip from "~/components/atoms/Tooltip";
import { TooltipContainer } from "~/components/atoms/TooltipContainer";

interface Props {
    left: ReactNode;
    tooltip?: string;
    right?: ReactNode;
    subContent?: ReactNode;
}

export function CardSectionRow({ left, tooltip, right, subContent }: Props) {
    const rightElement =
        typeof right === "string" ? (
            <span className="font-subheader-1 min-w-fit">{right}</span>
        ) : (
            right
        );
    return (
        <div className="text-gray-80">
            <div className="flex items-stretch justify-between gap-2 p-3">
                <div className="flex w-fit max-w-[30%] items-center gap-2">
                    <span className="font-body">{left}</span>
                    {tooltip && (
                        <InformationTooltip>
                            <TooltipContainer>{tooltip}</TooltipContainer>
                        </InformationTooltip>
                    )}
                </div>
                {rightElement}
            </div>
            {subContent}
            <hr />
        </div>
    );
}
